module.exports = __webpack_public_path__ + "static/img/bannerBg4.7c68f4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg4.png
// module id = I2Vt
// module chunks = 1